"use strict"

import axios from 'axios'

export const isBrowser = () =>
    typeof window !== "undefined"

export const handleLogin = async (number, email) => {
    const payload = {
        email: email,
        number: number,
        contract: 'wecare_plus'
    }

    const result = await axios.post(process.env.VUE_APP_API_BASE_URL + 'wecare_plus/login', payload)

    window.sessionStorage.access_token = result.data.bearer

    return result
}

export const isLoggedIn = () => {
    return !!window.sessionStorage.getItem('access_token')
}

export const logout = callback => {
    setUser({})
    callback()
}

// Subscription
export const getSubscription = async () => {
    const result = await request('subscription')
    return result
}

// Claim
export const claim = async (payload) => {
    const result = await requestPost('claim', payload)
    return result
}

const request = async (endpoint) => {
    const result = await axios.request({
        url: process.env.VUE_APP_API_BASE_URL + 'wecare_plus/' + endpoint,
        method: 'get',
        headers: {
            Authorization: 'Bearer ' + window.sessionStorage.access_token
        }
    })

    return result
}


const requestPost = async (endpoint, payload) => {
    const result = await axios.request({
        url: process.env.VUE_APP_API_BASE_URL + 'wecare_plus/' + endpoint,
        method: 'post',
        data: payload,
        headers: {
            Authorization: 'Bearer ' + window.sessionStorage.access_token
        }
    })

    return result
}